import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, List, ListItem, ListItemText, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AlertCustom } from 'shared/ui/alert/AlertCustom';
import { EmployeeFormFields } from './EmployeeFormFields';
import type { UseEmployeeFormReturn } from './hooks/useEmployeeForm';

interface EmployeeFormDialogProps {
    open: boolean;
    /** Clave i18n del título del diálogo */
    title: string;
    /** Clave i18n del botón de submit */
    submitLabel: string;
    form: UseEmployeeFormReturn;
    onSubmit: () => void;
}

const EmployeeFormDialog = ({ open, title, submitLabel, form, onSubmit }: EmployeeFormDialogProps) => {
    const { t } = useTranslation();
    const { alert, setAlert, closing, getTooltip, isDisabled, loadingSubmit } = form;

    const tooltip = getTooltip();

    return (
        <Dialog open={open} onClose={() => closing(false)} fullWidth maxWidth="md">
            <DialogTitle>{t(title)}</DialogTitle>

            <Box sx={{ top: 0, zIndex: 10, pb: 1 }}>
                <AlertCustom alerts={alert} setAlerts={setAlert} closeForm={() => closing(true)} t={t} />
            </Box>

            <DialogContent>
                <Box sx={{ mt: 1 }}>
                    <EmployeeFormFields form={form} />
                </Box>
            </DialogContent>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2 }}>
                <Button variant="outlined" onClick={() => closing(false)}>
                    {t('common.cancel')}
                </Button>

                <Tooltip
                    arrow
                    title={
                        Array.isArray(tooltip) && tooltip.length > 0 ? (
                            <List dense disablePadding>
                                {tooltip.map((msg, i) => (
                                    <ListItem key={i} disablePadding>
                                        <ListItemText primary={<Typography variant="caption">• {msg}</Typography>} />
                                    </ListItem>
                                ))}
                            </List>
                        ) : null
                    }
                >
                    <span>
                        <Button variant="contained" disabled={isDisabled || loadingSubmit} onClick={onSubmit}>
                            {loadingSubmit ? <CircularProgress color="inherit" size={20} /> : t(submitLabel)}
                        </Button>
                    </span>
                </Tooltip>
            </Box>
        </Dialog>
    );
};

export { EmployeeFormDialog };
